import { EyeIcon, EyeOffIcon, GearIcon, TrashIcon } from "../../ui/icons.tsx"
import { removeStrategy, type StrategyInstance, updateStrategy } from "../workspace/workspaceStore.ts"
import { formatMoney, tone } from "./format.ts"
import { strategyInfoFor, usePaneBacktest } from "./strategyResults.ts"

/** The strategy's row in a pane's legend: name, net profit, and hide / settings / remove. */
export function StrategyLegend({ instance, onOpenSettings, pane }: {
  readonly pane: number
  readonly instance: StrategyInstance
  readonly onOpenSettings: () => void
}) {
  const backtest = usePaneBacktest(pane)
  const report = backtest?.result?.report
  return (
    <ul className="indicator-legend strategy-legend">
      <li className={instance.hidden ? "legend-hidden" : ""} onDoubleClick={onOpenSettings}>
        <span className="legend-name">{strategyInfoFor(backtest, instance.id)?.title ?? "Strategy"}</span>
        {backtest?.error || backtest?.currencyProblem
          ? <span className="legend-error" title={backtest.error ?? backtest.currencyProblem?.message}>failed</span>
          : report && (
            <span className={`legend-value ${tone(report.performance.all.netProfit)}`} title="Net profit">
              {formatMoney(report.performance.all.netProfit, report.currency)}
            </span>
          )}
        {backtest?.running && <span className="legend-inputs">running…</span>}
        <span className="legend-actions">
          <button type="button" title={instance.hidden ? "Show" : "Hide"} onClick={() => updateStrategy(pane, { hidden: !instance.hidden })}>
            {instance.hidden ? <EyeOffIcon /> : <EyeIcon />}
          </button>
          <button type="button" title="Settings" onClick={onOpenSettings}>
            <GearIcon />
          </button>
          <button type="button" title="Remove" onClick={() => removeStrategy(pane)}>
            <TrashIcon />
          </button>
        </span>
      </li>
    </ul>
  )
}
